import { Button } from '@curology/ui-components-web/react/Button';
import { ProductCard } from '@curology/ui-components-web/react/Card/ProductCard';
import { ProductCardContent } from '@curology/ui-components-web/react/Card/ProductCard/ProductCardContent';
import { ProductCardImage } from '@curology/ui-components-web/react/Card/ProductCard/ProductCardImage';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { RxCardPricing } from '@/components/product-selection/components/RxCardPricing/RxCardPricing';
import { useSelectedItemIds } from '@/components/product-selection/hooks/useSelectedItemIds';
import { DATA_KEYS } from '@/consts/dataKeys';
import { type Card } from '@/types/productSelectionAndCheckout/types';

export const SwitchRxCard = ({
  onSuccess = () => {},
  rxCard,
  alternateRxCard,
}: {
  onSuccess?: () => void;
  rxCard: Card;
  alternateRxCard: Card;
}) => {
  const { patient } = useDataProvider(DATA_KEYS.productSelection);
  const { swapCard } = useSelectedItemIds();

  return (
    <ProductCard>
      <ProductCardContent
        horizontal
        className="-cur-mb-3"
        image={
          <div className="cur-flex cur-flex-col cur-h-full cur-w-full cur-aspect-[3/4]">
            <ProductCardImage
              alt={alternateRxCard.modal.image.alt}
              aspectRatio="auto"
              className="cur-h-full"
              src={alternateRxCard.modal.image.url}
            />
          </div>
        }
        meta={
          <>
            <Typography size="body">
              {alternateRxCard.bodyDescription}
            </Typography>
            <RxCardPricing rxCard={alternateRxCard} />
            <Button
              buttonType="primary"
              onClick={() => {
                swapCard({
                  patient,
                  card: rxCard,
                  alternateCard: alternateRxCard,
                });
                onSuccess();
              }}
            >
              Choose this
            </Button>
          </>
        }
        title={
          <Typography as="p" size="h3" weight="bold">
            {alternateRxCard.name}
            <sup>Rx</sup>
          </Typography>
        }
      ></ProductCardContent>
    </ProductCard>
  );
};
